import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@dashboard/components/Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import { toast } from '@dashboard/context/ToastContext';
import { useCreateBlankAIPage } from '@dashboard/hooks/queries/useAIQueries';
import getPageTypeLabel from '@dashboard/services/getPageTypeLabel';

const PAGE_TYPES = [
  { type: 'checkout', label: 'Checkout page' },
  { type: 'event', label: 'Event' },
  { type: 'form', label: 'Form' },
];

export default function CreateWithAIButton({ pageType }) {
  const history = useHistory();
  const { mutateAsync, isPending } = useCreateBlankAIPage();

  const create = async type => {
    try {
      const { pageId } = await mutateAsync({ type });
      history.push(`/pages/${pageId}/customize?ai=1`);
    } catch {
      toast({
        title: `Couldn't create the ${getPageTypeLabel({ type })}. Try again.`,
        type: 'error',
      });
    }
  };

  if (pageType) {
    return (
      <Button
        appearance="ai"
        onClick={() => create(pageType)}
        disabled={isPending}
        loading={isPending}
      >
        Create with AI
      </Button>
    );
  }

  return (
    <DropdownMenu>
      {/* Radix opens the menu from its own handlers, which only read the trigger's disabled. */}
      <DropdownMenuTrigger asChild disabled={isPending}>
        <Button appearance="ai" disabled={isPending} loading={isPending}>
          Create with AI
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {PAGE_TYPES.map(({ type, label }) => (
          <DropdownMenuItem key={type} onSelect={() => create(type)}>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
